export default __webpack_public_path__ + "static/media/marslogo.12c856f6.svg";